/**
 * Parámetros de búsqueda de las rutas de comunidad.
 *
 * Como en el resto de la app, cada campo lleva `catch(undefined)`: una URL
 * escrita a mano, compartida o de una versión anterior no debe tumbar la
 * pantalla, sólo perder ese parámetro.
 */
import { z } from 'zod';

const postType = z
  .enum(['text', 'routine_share', 'recipe_share', 'workout', 'pr'])
  .optional()
  .catch(undefined);

const optionalId = z.string().min(1).max(64).optional().catch(undefined);
const optionalText = z.string().max(200).optional().catch(undefined);
const optionalNumber = z.coerce.number().finite().optional().catch(undefined);

/** `/community?tab=&type=&sort=` */
export const communityFeedSchema = z.object({
  tab: z.enum(['following', 'explore']).optional().catch(undefined),
  type: postType,
  sort: z.enum(['recent', 'trending']).optional().catch(undefined),
});
export type CommunityFeedSearch = z.infer<typeof communityFeedSchema>;

/** `/community/u/$handle?tab=` */
export const profileSchema = z.object({
  tab: z.enum(['posts', 'routines', 'recipes']).optional().catch(undefined),
});
export type ProfileSearch = z.infer<typeof profileSchema>;

/** `/community/search?q=` */
export const userSearchSchema = z.object({
  q: z.string().max(80).optional().catch(undefined),
});
export type UserSearchSearch = z.infer<typeof userSearchSchema>;

/**
 * `/community/compose?...`
 *
 * La marca personal viaja desglosada en la URL porque es lo que hay al terminar
 * un entrenamiento: la sesión aún puede no haber subido, pero la marca ya está
 * calculada en el dispositivo y se puede publicar tal cual.
 */
export const composeSchema = z.object({
  type: postType,
  routineId: optionalId,
  recipeId: optionalId,
  workoutSessionId: optionalId,
  prExerciseId: optionalId,
  prExerciseName: optionalText,
  prWeightKg: optionalNumber,
  prReps: optionalNumber,
  prEstimated1RmKg: optionalNumber,
  prPerformedAt: optionalText,
});
export type ComposeSearch = z.infer<typeof composeSchema>;
